import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HeaderNavigationProvider } from "./context/HeaderNavigationContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <HeaderNavigationProvider>
      <App />
    </HeaderNavigationProvider>
  </React.StrictMode>
);

reportWebVitals();
